const IconOffers = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48">
    <path
      d="M8,12h32v28H8V12z"
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2.5"
    />
    <line
      x1="8"
      y1="20"
      x2="40"
      y2="20"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <line
      x1="16"
      y1="12"
      x2="16"
      y2="8"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="32"
      y1="12"
      x2="32"
      y2="8"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M16,28l4,4l8-8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconOffers;
